// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37PfM","label":"styles_label__2f7OJ"};